
<div class="scroll-popup">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'alert.documents_cancel_flow' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider class="mb-2"></mat-divider>
  <ng-container *ngIf="subTitle" >
    <span [innerHTML]="subTitle | translate" class="subtitle"></span>
  </ng-container>
  <mat-dialog-content class="mt-3">
    <div class="row" style="margin: 0px; padding: 0px;">
      <div class="col-12" style="margin: 0px; padding: 0px;">
        <mat-dialog-content>
          <div class="row">
            <div class="col-12"><label class="mat-dialog-title" style="margin-top: -5px;font-size: 16px">{{'form.reason_cancel' | translate}}<span style="color: red">*</span></label></div>
            <div class="col-12" style="margin-top: -30px;">
              <mat-form-field style="width: 100%;">
                <textarea class="classtextarea" matInput style="margin-top: 5px;resize: none;" maxlength="250" appAutoFocus [disabled]="isProcess"  (focusout)="inputReasonValue = inputReasonValue.trim()"   type="text" (change)="changeReason()" rows="3" [(ngModel)]="inputReasonValue" ></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-dialog-content>
        <span *ngIf="checkReasonValue" style="color: #ee0033">{{'validation.reason_cancel' | translate}}</span>
      </div>
      <div style="margin: 5px 0">
        <span>{{'title.lot_cancel_flow_1' | translate }} <span style="color: red">{{listDataPopup.length}}</span> {{'title.lot_cancel_flow_2' | translate }}</span>
      </div>
      <div class="col-12" style="margin: 0px; padding: 0px;">
        <div class="mat-table-container scroll-table">
          <span *ngIf="isShowProgress" class="mx-3 mat-panel-title" style="border: none !important;">{{'search_form.processing' | translate}} {{percent}}%</span>
          <mat-progress-bar *ngIf="isShowProgress" mode="determinate" color="primary" [bufferValue] = "100" [value] = "percent">
          </mat-progress-bar>
          <mat-table [dataSource]="listData" >
            <!-- check -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element;let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.order ? element.order :element.orderNo}}
              </mat-cell>
            </ng-container>

            <!-- Full name -->
            <ng-container matColumnDef="Document">
              <mat-header-cell *matHeaderCellDef style="max-width: 25%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_document' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="max-width: 25%;">
                        <span matTooltip="{{element.name ? element.name : element.contractNameCode}}" class="fix-width" style="margin-left: -5px;">
          {{element.name ? element.name : element.contractNameCode }}
        </span>
              </mat-cell>
            </ng-container>

            <!-- Khach hang/noi bo -->
            <ng-container matColumnDef="UserSign">
              <mat-header-cell *matHeaderCellDef  class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 20%;">
                {{'form.contracting_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="max-width: 20%;">
                        <span matTooltip="{{element.allName}}" class="fix-width" style="margin-left: -5px;">
          {{element.allName}}
        </span>
              </mat-cell>
            </ng-container>

            <!-- Vai tro -->
            <ng-container matColumnDef="status" *ngIf="isNotAttestedUser">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'enterprise_contract.table_headers.document_status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.status === enumContractStatus.DRAFT" style="margin-right: 0px;">
                  {{'search_form.draft' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.PROCESSING" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.processing' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.denied_sign' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.FINISHED" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.finish' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.CONNECTING" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                        class='wait-confirm-enterprice-no-moit__tag'
                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="result">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                        <span>
          {{'headertable.result' | translate}}
        </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 10%;"
                        (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width text-center" [ngStyle]="renderStatusColor(element.statusName)">{{renderStatus(element.statusName)}}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="detail">
              <mat-header-cell *matHeaderCellDef  >
                        <span>
          {{'view_document_information.table_headers.partiesSignContract.action' | translate}}
        </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ !isShowProgress ? element.errorMessage  : '' }}"
                        (click)="$event.stopPropagation()" >
                <span class="fix-width">{{element.errorMessage ? element.errorMessage : ''}}</span>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
            </mat-row>
          </mat-table>
        </div>
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
        </app-pagination>
        <mat-dialog-actions align="center" style="    margin-top: -32px;">
          <button *ngIf="!isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
          </button>
          <button [disabled]="!inputReasonValue" *ngIf="!isProcess" mat-raised-button cdkFocusInitial (click)="onClickConfirmButton()" color="primary">
            <mat-icon class="mr-0">done_all</mat-icon>
            {{'button.confirm' | translate}}
          </button>
          <!-- đóng popup -->
          <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.close' | translate}}
          </button>

          <!-- dừng ký -->
          <button *ngIf="isProcess" mat-stroked-button color="primary" class="mr-3" (click)="onClickStopSign()" type="button"
                  [disabled] = "isStop">
            <mat-icon class="mr-0">block</mat-icon>
            {{'button.stop_progress' | translate}}
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  </mat-dialog-content>
</div>

